import React from 'react';
import ReactApexChart from 'react-apexcharts';

const Ybar = ({ ints }) => {

    const [chartData, setChartData] = React.useState({
        series: [
            {
                name: ['Download Traffic'],
                data: [
                    ints?.int?.[0]?.rx?.totalTraffic ? parseFloat(ints.int[0].rx.totalTraffic).toFixed() : 0,
                    ints?.int?.[0]?.tx?.totalTraffic ? parseFloat(ints.int[0].tx.totalTraffic).toFixed() : 0,
                ],
            },
            {
                name: 'Upload Traffic',
                data: [
                    ints?.int?.[1]?.rx?.totalTraffic ? parseFloat(ints.int[1].rx.totalTraffic).toFixed() : 0,
                    ints?.int?.[1]?.tx?.totalTraffic ? parseFloat(ints.int[1].tx.totalTraffic).toFixed() : 0,
                ],
            },
        ],
        options: {
            chart: {
                type: 'bar',
                height: 300,
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    barHeight: '50%',
                    dataLabels: {
                        position: 'end',
                    }
                }
            },
            dataLabels: {
                enabled: true,
                // offsetX: -6,
                style: {
                    fontSize: '1em',
                    colors: ['var(--textPrimary)']
                }
            },
            stroke: {
                show: true,
                width: 1,
                colors: ['var(--textSecondary)']
            },
            tooltip: {
                shared: true,
                intersect: false
            },
            xaxis: {
                categories: [ints.int[0].state == 0 ? `${ints.int[0].type} (Active)` : `${ints.int[0].type} (Inactive)`, ints.int[1].state == 0 ? `${ints.int[1].type} (Active)` : `${ints.int[1].type} (Inactive)`],
                labels: {
                    style: {
                        colors: ['var(--textPrimary)'],
                        fontSize: '0.8em',
                        fontWeight: 'bold'
                    }
                }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: ['var(--textPrimary)'],
                        fontSize: '0.8em',
                        fontWeight: 'bold'
                    }
                }
            },
            colors: ['var(--barPrimary)', 'var(--barSecondary)'],
            legend: {
                show: true,
                position: 'bottom',
                horizontalAlign: 'center',
                onItemClick: {
                    toggleDataSeries: true
                },
                onItemHover: {
                    highlightDataSeries: true
                },
                markers: {
                    width: 10,
                    height: 10,
                    radius: 12,
                    fillColors: ['var(--barPrimary)', 'var(--barSecondary)']
                },
                labels: {
                    colors: ['var(--textPrimary)', 'var(--textPrimary)'],
                    fontSize: '1em',
                    fontWeight: 'bold'
                }
            }
        }
    });

    return (
        <div id="chart">
            <ReactApexChart options={chartData.options} series={chartData.series} type="bar" height={250} />
        </div>
    );
};

export default Ybar;